import axios from 'axios'
import React, { Fragment, useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'

import { BsArrowDown, BsArrowUp, BsBank } from 'react-icons/bs'
import { RxDoubleArrowLeft, RxDoubleArrowRight } from 'react-icons/rx'
import { CiReceipt } from "react-icons/ci";
import { capitalizeWords, formatToCurrency } from '../../Utils/general'
import { useStateValue } from '../../Utils/StateProvider'

import loading_image from '../../Contents/images/utils/progress.gif'
import TransactionReceipt from './TransactionReceipt'

const History = () => {
    const [{ url, customer }] = useStateValue()
    const [transactions, setTransactions] = useState([])
    const [txLength, setTxLength] = useState(0)
    const [listTitle, setListTitle] = useState('Transactions History')
    const [conditions, setConditions] = useState({ separator: "AND", data: []})
    const [limit, setLimit] = useState(10)
    const [filterData, setFilterData] = useState({})
    const [cookies] = useCookies(['bearerToken'])
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [receiptPlaceHolder, setReceiptPlaceHolder] = useState(null)

    const getTransactions = async (source = null) => {
        setLoading(true)
        const options = source ? {
            cancelToken: source.token,
            headers: {
                Authorization: `Bearer ${cookies.bearerToken}`
            }
        } : {
            headers: {
                Authorization: `Bearer ${cookies.bearerToken}`
            }
        }
        try {
            const _transactions = await axios.post(`${url}/api/tx/page`, {
                uid: customer.uid,
                limit: parseInt(limit),
                conditions,
                page
            }, options)

            setTransactions(_transactions.data.transactions)
            setTxLength(_transactions.data.length)
        } catch(err) {
            console.error(err.message)
        } finally {
            setLoading(false)
        }
    }
    const closePreview = () => setReceiptPlaceHolder(null)
    const previewReceipt = (transaction) => {
        setReceiptPlaceHolder(<TransactionReceipt transaction={transaction} closeMethod={closePreview} />)
    }

    useEffect(() => {
        const _conditions = {
            separator: " AND ",
            data: []
        }

        if (filterData.from) _conditions.data.push(["timestamp", ">=", filterData.from])
        if (filterData.to) _conditions.data.push(["timestamp", "<=", filterData.to])
        if (filterData.transaction_type) _conditions.data.push(["transaction_type", "=", filterData.transaction_type])
        if (filterData.transaction_type === "all") _conditions.data = _conditions.data.filter(datum => datum[0] !== "transaction_type")
        if (filterData.min) _conditions.data.push(["amount", ">=", filterData.min])
        if (filterData.max) _conditions.data.push(["amount", "<=", filterData.max])
        if (filterData.institution) _conditions.data.push(["institutions", "=", filterData.institution])

        setConditions(_conditions)

    }, [filterData])

    useEffect(() => {
        const source = axios.CancelToken.source()
        getTransactions(source)

        return () => {
            source.cancel()
        }
    }, [page])

    return (
        <div className='display'>
            <div className="transactions-history">
                <div className="history-container">
                    <h1>{listTitle}</h1>
                    {
                        transactions.length > 0 ? (
                            <Fragment>
                                <ul className='history'>
                                    {
                                        transactions?.map((transaction, index) => (
                                            <li key={index} className={`history-item ${transaction?.transaction_type}`}>
                                                <div className="details">
                                                    <div className="abbreviation-icon">
                                                    {
                                                        transaction?.account_name.split(' ').length > 1 ? `${transaction?.account_name.split(' ')[0][0].toUpperCase()}${transaction?.account_name.split(' ')[1][0].toUpperCase()}` : transaction?.account_name.slice(0, 3).toUpperCase()
                                                    }
                                                    </div>
                                                    <div className="data">
                                                        <h3>{capitalizeWords(transaction?.account_name)}</h3>
                                                        <p>{new Date(transaction?.timestamp).toLocaleString()}</p>
                                                    </div>
                                                </div>
                                                <div className="amount">
                                                    {
                                                        transaction?.transaction_type === 'credit' ? (
                                                            <BsArrowDown />
                                                        ) : (
                                                            <BsArrowUp />
                                                        )
                                                    }
                                                    <strong>{formatToCurrency(transaction?.amount, customer?.currency)}</strong>
                                                </div>
                                                <div className="tx-status">
                                                {
                                                    transaction?.status == 1 ? (
                                                        <strong className="completed">Completed</strong>
                                                    ) : (
                                                        <strong className="processing">Processing</strong>
                                                    )
                                                }
                                                </div>
                                                <div className="pdf">
                                                    <CiReceipt onClick={() => previewReceipt(transaction)} />
                                                </div>
                                            </li>                                            
                                        ))
                                    }
                                </ul>
                                {
                                    txLength > limit && (
                                        <div className="pagination">
                                            {
                                                page > 1 && (
                                                    <div className="back" onClick={() => setPage(page - 1)}>
                                                        <div className="ball">
                                                            Previous <RxDoubleArrowLeft />
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            {
                                                txLength/limit > page && (
                                                    <div className="next" onClick={() => setPage(page + 1)}>
                                                        <div className="ball">
                                                            Next <RxDoubleArrowRight />
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    )
                                }
                            </Fragment>
                        ) : (
                            <div className='no-list'>No transactions match the filter</div>
                        )
                    }
                </div>
                <div className="history-filter">
                    <div className="control-box">
                        <div className="control-row split-row">
                            <div className="date-column">
                                <label htmlFor="from">From:</label>
                                <input type="date" name="from" id="from" value={filterData.from || ''} onChange={e => setFilterData({...filterData, from: e.target.value})} />
                            </div>
                            <div className="date-column">
                                <label htmlFor="to">To:</label>
                                <input type="date" name="to" id="to" value={filterData.to || ''} onChange={e => setFilterData({...filterData, to: e.target.value})} />
                            </div>
                        </div>
                        <div className="control-row">
                            <div className="select-column">
                                <label htmlFor="transaction_type">Transaction Type</label>
                                <select name="transaction_type" id="transaction_type" value={filterData.transaction_type || 'all'} onChange={e => setFilterData({...filterData, transaction_type: e.target.value})} >
                                    <option value="all">All</option>
                                    <option value="debit">Debit</option>
                                    <option value="credit">Credit</option>
                                </select>
                            </div>
                        </div>
                        <div className="control-row split-row">
                            <div className="amount-column">
                                <label htmlFor="min">Min</label>
                                <input type="number" name="min" id="min" value={filterData.min} onChange={e => setFilterData({...filterData, min: e.target.value})}/>
                            </div>
                            <div className="amount-column">
                                <label htmlFor="max">Max</label>
                                <input type="number" name="max" id="max" value={filterData.max} onChange={e => setFilterData({...filterData, max: e.target.value})}/>
                            </div>
                        </div>
                        <div className="control-row">
                            <div className="default-column">
                                <label htmlFor="institution">Bank</label>
                                <input type="text" name="institution" id="institution" value={filterData.institution} onChange={e => setFilterData({...filterData, institution: e.target.value})}/>
                                <BsBank />
                            </div>
                        </div>
                        <div className="control-row split-row">
                            <div className="default-column">
                                <label htmlFor="limit">list range</label>
                                <input type="number" name="limit" id="limit" value={limit} onChange={e => setLimit(e.target.value)}/>
                            </div>
                        </div>
                        <div className="control-row">
                            <button onClick={getTransactions}>Apply</button>
                        </div>
                        <div className="processor">
                        {
                            loading && (
                                <img src={loading_image} alt="Processing..." />
                            )
                        }
                        </div>
                    </div>
                </div>
            </div>
            {receiptPlaceHolder}
        </div>
    )
}

export default History
